import Vue from 'vue'
import defaultState from './state'

export default {
  initStore(state) {
    Object.assign(state, defaultState)
  },
  setActiveTab(state, activeTab) {
    Vue.set(state, 'activeTab', activeTab)
  },
  // 搜尋關鍵字、起始時間、結束時間
  setKw(state, kw) {
    Vue.set(state, 'kw', kw)
  },
  setRule(state, rule) {
    Vue.set(state, 'rule', rule)
  },
  setSearchStart(state, start) {
    Vue.set(state.search, 'start', start)
  },
  setSearchEnd(state, end) {
    Vue.set(state.search, 'end', end)
  },
  // 立即單
  setInstantList(state, list) {
    Vue.set(state, 'instantList', list)
  },
  setPick(state, pick) {
    Vue.set(state, 'instantPick', pick)
  },
  setInstantPagingNpp(state, npp) {
    Vue.set(state.instantPaging, 'npp', npp)
  },
  setInstantPagingCurrentPage(state, currentPage) {
    Vue.set(state.instantPaging, 'currentPage', currentPage)
  },
  setInstantPagingTotalEntries(state, totalEntries) {
    Vue.set(state.instantPaging, 'totalEntries', totalEntries)
  },
  setInstantPagingTotalPages(state, totalPages) {
    Vue.set(state.instantPaging, 'totalPages', totalPages)
  },
  // 路招單
  setRoadList(state, list) {
    Vue.set(state, 'roadList', list)
  },
  setRoadPagingNpp(state, npp) {
    Vue.set(state.roadPaging, 'npp', npp)
  },
  setRoadPagingCurrentPage(state, currentPage) {
    Vue.set(state.roadPaging, 'currentPage', currentPage)
  },
  setRoadPagingTotalEntries(state, totalEntries) {
    Vue.set(state.roadPaging, 'totalEntries', totalEntries)
  },
  setRoadPagingTotalPages(state, totalPages) {
    Vue.set(state.roadPaging, 'totalPages', totalPages)
  },
  // 預約前派單
  setReserveBeforeList(state, list) {
    Vue.set(state, 'reserveBeforeList', list)
  },
  setReserveBeforePagingNpp(state, npp) {
    Vue.set(state.reserveBeforePaging, 'npp', npp)
  },
  setReserveBeforePagingCurrentPage(state, currentPage) {
    Vue.set(state.reserveBeforePaging, 'currentPage', currentPage)
  },
  setReserveBeforePagingTotalEntries(state, totalEntries) {
    Vue.set(state.reserveBeforePaging, 'totalEntries', totalEntries)
  },
  setReserveBeforePagingTotalPages(state, totalPages) {
    Vue.set(state.reserveBeforePaging, 'totalPages', totalPages)
  },
  // 預約後派單
  setReserveAfterList(state, list) {
    Vue.set(state, 'reserveAfterList', list)
  },
  setReserveAfterPagingNpp(state, npp) {
    Vue.set(state.reserveAfterPaging, 'npp', npp)
  },
  setReserveAfterPagingCurrentPage(state, currentPage) {
    Vue.set(state.reserveAfterPaging, 'currentPage', currentPage)
  },
  setReserveAfterPagingTotalEntries(state, totalEntries) {
    Vue.set(state.reserveAfterPaging, 'totalEntries', totalEntries)
  },
  setReserveAfterPagingTotalPages(state, totalPages) {
    Vue.set(state.reserveAfterPaging, 'totalPages', totalPages)
  },
  // TODO 記得回來確認功能是否作用
  // 機場接送
  setAirportTransferList(state, list) {
    Vue.set(state, 'airportTransferList', list)
  },
  setAirportTransferPagingNpp(state, npp) {
    Vue.set(state.airportTransferPaging, 'npp', npp)
  },
  setAirportTransferPagingCurrentPage(state, currentPage) {
    Vue.set(state.airportTransferPaging, 'currentPage', currentPage)
  },
  setAirportTransferPagingTotalEntries(state, totalEntries) {
    Vue.set(state.airportTransferPaging, 'totalEntries', totalEntries)
  },
  setAirportTransferPagingTotalPages(state, totalPages) {
    Vue.set(state.airportTransferPaging, 'totalPages', totalPages)
  },
}



// WEBPACK FOOTER //
// ./src/store/transaction/mutations.js